import { DrawData } from '../../draw.constants';
import { FabricData, OBJECT_SOURCE_KEY } from '../draw-canvas.constants';

export function getMergedDrawObjects(
  answer?: DrawData | null,
  questionData?: DrawData | null
): FabricData | null {
  if (answer?.data?.objects.length && questionData?.data?.objects.length) {
    // Extract objects with elementSource from questionData
    const questionObjects = questionData.data.objects.filter(
      obj => obj[OBJECT_SOURCE_KEY]
    );

    // Combine with answer objects
    const combinedObjects = [...questionObjects, ...answer.data.objects];

    return {
      ...answer.data,
      objects: combinedObjects,
    };
  } else if (questionData?.data?.objects.length) {
    // Only questionData exists, filter for objects with elementSource
    const questionObjects = questionData.data.objects.filter(
      obj => obj[OBJECT_SOURCE_KEY]
    );

    return {
      ...questionData.data,
      objects: questionObjects,
    };
  } else if (answer?.data?.objects.length) {
    // Only answer exists
    return answer.data;
  }

  return null;
}
